/**
 * Pet Breed Selector Component
 * 
 * Provides access to pet breed data fetched from Shopify metaobjects via Liquid
 */

// Only define if not already defined (prevent duplicate declaration errors)
if (typeof window !== 'undefined' && !window.PetBreedSelector) {
  class PetBreedSelector {
    constructor() {
      this.breeds = window.petBreeds || { dog: [], cat: [] };
      this.initCache();
    }

    initCache() {
      // Cache breeds in sessionStorage if not already cached
      const cacheKey = 'petBreedsCache';
      if (!sessionStorage.getItem(cacheKey) && window.petBreeds) {
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify(window.petBreeds));
        } catch (e) {
          // sessionStorage may not be available, ignore
          console.warn('Could not cache pet breeds:', e);
        }
      }
    }

    getPetBreeds(petType) {
      // Validate pet type
      if (!petType || typeof petType !== 'string') {
        console.warn('Invalid pet type provided to getPetBreeds:', petType);
        return [];
      }

      const normalizedType = petType.toLowerCase().trim();
      
      if (normalizedType !== 'dog' && normalizedType !== 'cat') {
        console.warn('Pet type must be "dog" or "cat", got:', petType);
        return [];
      }

      // Get breeds from window.petBreeds (set by Liquid)
      const breeds = this.breeds[normalizedType] || [];
      
      if (!Array.isArray(breeds)) {
        console.warn(`Breeds for ${normalizedType} is not an array:`, breeds);
        return [];
      }

      return breeds;
    }

    // Get all breeds for both types
    getAllBreeds() {
      return {
        dog: this.getPetBreeds('dog'),
        cat: this.getPetBreeds('cat')
      };
    }

    // Check if breeds are available
    hasBreeds(petType) {
      const breeds = this.getPetBreeds(petType);
      return breeds.length > 0;
    }
  }

  // Export singleton instance
  window.PetBreedSelector = PetBreedSelector;
  window.petBreedSelector = new PetBreedSelector();
}

// For ES modules (if needed)
if (typeof module !== 'undefined' && module.exports && !module.exports.PetBreedSelector) {
  module.exports = window.PetBreedSelector;
}

